export const enum IdentificationProvider {
    IDNOW = 'IDNOW',
    WEBID = 'WEBID',
}
